<template>
  <v-card
    class="px-3"
    flat
    tile
  >
    <v-row dense>
      <v-col>
        <span class="text-body-1 font-weight-bold grey--text text--darken-3">
          {{ $t("m.speedFuel") }}
        </span>
      </v-col>
    </v-row>

    <v-card
      class=""
      flat
      tile
    >
      <v-row
        dense
        align="center"
      >
        <v-col class="text-body-2 grey--text text--darken-2 text-right">
          {{ $t("m.fuelType") }}
          </span>
        </v-col>
        <v-col>
          <v-select
            :items="FOTypeArr"
            label="FO"
            outlined
            dense
            hide-details="true"
            v-model="$store.state.vessel.fuelForm.FOType"
            item-text="DICTNAME"
            item-value="DICTID"
          />
        </v-col>
        <v-col>
          <v-select
            :items="LSFOTypeArr"
            label="LSFO"
            outlined
            dense
            hide-details="true"
            v-model="$store.state.vessel.fuelForm.LSFOType"
            item-text="DICTNAME"
            item-value="DICTID"
          />
        </v-col>
        <v-col>
          <v-select
            :items="DOTypeArr"
            label="DO"
            outlined
            dense
            hide-details="true"
            v-model="$store.state.vessel.fuelForm.DOType"
            item-text="DICTNAME"
            item-value="DICTID"
          />
        </v-col>
        <v-col>
          <v-select
            :items="LSDOTypeArr"
            label="LSDO"
            outlined
            dense
            hide-details="true"
            v-model="$store.state.vessel.fuelForm.LSDOType"
            item-text="DICTNAME"
            item-value="DICTID"
          />
        </v-col>
      </v-row>
    </v-card> <!-- 列表 row fuelType -->

    <v-card
      class=""
      flat
      tile
    >
      <v-row
        dense
        align="center"
        class="py-2 mt-4"
      >
        <v-col class="text-body-2 font-weight-bold grey--text text--darken-3">
          At SEA
        </v-col>
        <v-col class="text-body-2 grey--text text--darken-2">
          {{ $t("m.speed") }} ({{ $t("m.knots") }})
        </v-col>
        <v-col class="text-body-2 grey--text text--darken-2">
          {{ $t("m.foDoConsump") }}
        </v-col>
        <v-col class="text-body-2 grey--text text--darken-2">
          {{ $t("m.lsFoLSDoConsump") }}
        </v-col>

        <v-col class="text-center text-body-2 font-weight-bold grey--text text--darken-3">
          At PORT
        </v-col>
        <v-col class="text-body-2 grey--text text--darken-2">
          {{ $t("m.foDoConsump") }}
        </v-col>
        <v-col class="text-body-2 grey--text text--darken-2">
          {{ $t("m.lsFoLSDoConsump") }}
        </v-col>
      </v-row>

      <v-row
        dense
        align="center"
      >
        <v-col class="text-body-2 grey--text text--darken-3">
          BALLAST(Full)
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            :label="$t('m.speed')"
            background-color="#E3F2FD"
            v-model="$store.state.vessel.fuelForm.BallastFullSpeed"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="FO"
            v-model="$store.state.vessel.fuelForm.FOFullBallast"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSFO"
            v-model="$store.state.vessel.fuelForm.LSFOFullBallast"
          />
        </v-col>

        <v-col class="text-center text-body-2 grey--text text--darken-3">
          IDLE
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="FO"
            v-model="$store.state.vessel.fuelForm.FOPortIdle"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSFO"
            v-model="$store.state.vessel.fuelForm.LSFOPortIdle"
          />
        </v-col>
      </v-row> <!-- end BALLAST(Full) -->

      <v-row
        dense
        align="center"
      >
        <v-col class="text-body-2 grey--text text--darken-3">
          BALLAST(Eco)
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            :label="$t('m.speed')"
            background-color="#E3F2FD"
            v-model="$store.state.vessel.fuelForm.BallastEcoSpeed"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="FO"
            v-model="$store.state.vessel.fuelForm.FOEcoBallast"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSFO"
            v-model="$store.state.vessel.fuelForm.LSFOEcoBallast"
          />
        </v-col>

        <v-col class="text-center text-body-2 grey--text text--darken-3" />
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="DO"
            v-model="$store.state.vessel.fuelForm.DOPortIdle"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSDO"
            v-model="$store.state.vessel.fuelForm.LSDOPortIdle"
          />
        </v-col>
      </v-row> <!-- end BALLAST(Eco) -->

      <v-row
        dense
        align="center"
        class="mt-1"
      >
        <v-col class="text-body-2 grey--text text--darken-3">
          LADEN(Full)
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            :label="$t('m.speed')"
            background-color="#E3F2FD"
            v-model="$store.state.vessel.fuelForm.LadenFullSpeed"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="FO"
            v-model="$store.state.vessel.fuelForm.FOFullLaden"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSFO"
            v-model="$store.state.vessel.fuelForm.LSFOFullLaden"
          />
        </v-col>

        <v-col class="text-center text-body-2 grey--text text--darken-3">
          WORK
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="FO"
            v-model="$store.state.vessel.fuelForm.FOPortWork"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSFO"
            v-model="$store.state.vessel.fuelForm.LSFOPortWork"
          />
        </v-col>
      </v-row> <!-- end LADEN(Full) -->

      <v-row
        dense
        align="center"
      >
        <v-col class="text-body-2 grey--text text--darken-3">
          LADEN(Eco)
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            :label="$t('m.speed')"
            background-color="#E3F2FD"
            v-model="$store.state.vessel.fuelForm.LadenEcoSpeed"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="FO"
            v-model="$store.state.vessel.fuelForm.FOEcoLaden"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSFO"
            v-model="$store.state.vessel.fuelForm.LSFOEcoLaden"
          />
        </v-col>

        <v-col class="text-center text-body-2 grey--text text--darken-3" />
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="DO"
            v-model="$store.state.vessel.fuelForm.DOPortWork"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSDO"
            v-model="$store.state.vessel.fuelForm.LSDOPortWork"
          />
        </v-col>
      </v-row> <!-- end LADEN(Eco) -->

      <v-row
        dense
        align="center"
        class="mt-3"
      >
        <v-col class="text-body-2 grey--text text--darken-3">
          {{ $t("m.doAtSea") }}
        </v-col>
        <v-col class="" />
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="DO"
            v-model="$store.state.vessel.fuelForm.DOLaden"
          />
        </v-col>
        <v-col class="">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            label="LSDO"
            v-model="$store.state.vessel.fuelForm.LSDOLaden"
          />
        </v-col>
        <v-col class="" />
        <v-col class="" />
        <v-col class="" />
      </v-row> <!-- end Do Consumption -->
    </v-card> <!-- 列表 row -->
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'SpeedAndFuel',
  components: { },
  props: [
    'model', 'visible'
  ],
  data () {
    return {

    }
  },
  created () {

  },
  computed: {
    ...mapState({
      shipTypeArr: state => state.commons.shipTypeArr,
      countryArr: state => state.commons.countryArr,

      FOTypeArr: state => state.commons.lsfoTypeArr,
      LSFOTypeArr: state => state.commons.lsfoTypeArr,
      DOTypeArr: state => state.commons.lsdoTypeArr,
      LSDOTypeArr: state => state.commons.lsdoTypeArr
    })
  },
  watch: {

  },
  methods: {
    resetForm () {

    },

    clearForm () {

    }
  }

}
</script>

<style scoped>

</style>
